import { Component } from "react";
import { connect } from "react-redux";
import EdicionMasivaEntidad from "../../../../Components/EdicionMasivaEntidad";

// Backend: erp_backend/Controllers/edicionMasivaClientes.controllers.js
// Fuera a propósito: tipo de cliente (tiene su flujo de "Cambiar tipo"), cuentas contables,
// retenciones, archivos, datos de alumno y direcciones distintas de la principal.

const nombreUsuario = (u) => [u?.nombre, u?.apellidoPaterno, u?.apellidoMaterno].filter(Boolean).join(" ");
const dosDigitos = (n) => String(n ?? "").padStart(2, "0");

const GRUPOS = [
  {
    key: "generales",
    label: "Generales",
    color: "595959",
    fijo: true,
    columnas: ["ID", "Codigo", "Clave", "RFC", "Razon Social", "Nombre", "Apellido Paterno", "Apellido Materno", "Nombre Comercial"],
  },
  {
    key: "contacto",
    label: "Contacto",
    color: "2F54EB",
    columnas: [
      "Nombre Contacto General",
      "Celular",
      "Telefono",
      "Correo",
      "Correos Adicionales",
      "Pagina Web",
      "Nombre Contacto",
      "Telefono Contacto",
      "Correo Contacto",
      "Observaciones",
    ],
  },
  {
    key: "fiscales",
    label: "Fiscales",
    color: "1890FF",
    columnas: ["CURP", "Regimen Fiscal", "Uso de CFDI", "Forma de Pago", "Moneda"],
  },
  {
    key: "venta",
    label: "Venta",
    color: "52C41A",
    columnas: ["Vendedor", "Canal", "Proyecto", "Banco"],
  },
  {
    // Sólo con el permiso "Modificar parámetros de crédito", igual que en EditarCliente.
    key: "creditoPrecios",
    label: "Crédito y Precios",
    color: "FA8C16",
    columnas: [
      "Contado/Credito",
      "Dias Credito",
      "Limite Credito",
      "Limite Descuento",
      "Descuento Predeterminado",
      "Precio Contado",
      "Precio Credito",
      "Precio Online",
    ],
  },
  {
    key: "opciones",
    label: "Opciones",
    color: "722ED1",
    columnas: ["Leyenda", "Cliente de Portal", "Sin Fecha Vencimiento", "Impresion Especial", "Codigo Proveedor"],
  },
  {
    key: "direccion",
    label: "Dirección",
    color: "13C2C2",
    columnas: ["Codigo Postal", "Colonia", "Calle", "Numero", "Numero Interior"],
  },
];

const COLUMNAS = [
  { col: "Codigo", campo: "codigo", tipo: "soloLectura" },
  { col: "Clave", campo: "clave", tipo: "texto" },
  { col: "RFC", campo: "rfc", tipo: "rfc" },
  { col: "Razon Social", campo: "razonSocial", tipo: "mayusculas", patron: true },
  { col: "Nombre", campo: "nombre", tipo: "mayusculas", patron: true },
  { col: "Apellido Paterno", campo: "apellidoPaterno", tipo: "mayusculas", patron: true },
  { col: "Apellido Materno", campo: "apellidoMaterno", tipo: "mayusculas", patron: true },
  { col: "Nombre Comercial", campo: "nombreComercial", tipo: "mayusculas", patron: true },
  { col: "Nombre Contacto General", campo: "nombreContactoGeneral", tipo: "texto" },
  { col: "Celular", campo: "celular", tipo: "telefono" },
  { col: "Telefono", campo: "telefono", tipo: "telefono" },
  { col: "Correo", campo: "correo", tipo: "correo" },
  { col: "Correos Adicionales", campo: "correosAdicionales", tipo: "correos" },
  { col: "Pagina Web", campo: "paginaWeb", tipo: "texto" },
  { col: "Nombre Contacto", campo: "nombreContacto", tipo: "texto" },
  { col: "Telefono Contacto", campo: "telefonoContacto", tipo: "telefono" },
  { col: "Correo Contacto", campo: "correoContacto", tipo: "correo" },
  { col: "Observaciones", campo: "observaciones", tipo: "texto" },
  { col: "CURP", campo: "curp", tipo: "mayusculas" },
  { col: "Regimen Fiscal", campo: "regimenFiscalId", tipo: "referencia", catalogo: "regimenes" },
  { col: "Uso de CFDI", campo: "usoDeCFDIID", tipo: "referencia", catalogo: "usos" },
  { col: "Forma de Pago", campo: "formaDePagoId", tipo: "referencia", catalogo: "formasDePago" },
  { col: "Moneda", campo: "monedaId", tipo: "referencia", catalogo: "monedas" },
  { col: "Vendedor", campo: "vendedorId", tipo: "referencia", catalogo: "vendedores" },
  { col: "Canal", campo: "canalDeVentaId", tipo: "referencia", catalogo: "canales" },
  { col: "Proyecto", campo: "proyectoId", tipo: "referencia", catalogo: "proyectos" },
  { col: "Banco", campo: "bancoId", tipo: "referencia", catalogo: "bancos" },
  { col: "Contado/Credito", campo: "contado", tipo: "enum", labels: { 1: "Contado", 2: "Credito" } },
  { col: "Dias Credito", campo: "diasCredito", tipo: "numero" },
  { col: "Limite Credito", campo: "limiteCredito", tipo: "numero" },
  { col: "Limite Descuento", campo: "limiteDescuento", tipo: "numero" },
  { col: "Descuento Predeterminado", campo: "descuentoPredeterminado", tipo: "numero" },
  { col: "Precio Contado", campo: "precioContadoId", tipo: "referencia", catalogo: "precios" },
  { col: "Precio Credito", campo: "precioCreditoId", tipo: "referencia", catalogo: "precios" },
  { col: "Precio Online", campo: "precioOnlineId", tipo: "referencia", catalogo: "precios" },
  { col: "Leyenda", campo: "leyenda", tipo: "bool" },
  { col: "Cliente de Portal", campo: "clienteDePortal", tipo: "bool" },
  { col: "Sin Fecha Vencimiento", campo: "sinFechaVencimiento", tipo: "bool" },
  { col: "Impresion Especial", campo: "impresionEspecial", tipo: "bool" },
  { col: "Codigo Proveedor", campo: "codigoProveedor", tipo: "texto", max: 9 },
  { col: "Codigo Postal", campo: "cp", tipo: "direccion" },
  { col: "Colonia", campo: "colonia", tipo: "direccion" },
  { col: "Calle", campo: "calle", tipo: "direccion" },
  { col: "Numero", campo: "numeroCalle", tipo: "direccion" },
  { col: "Numero Interior", campo: "numeroInterior", tipo: "direccion" },
];

const catalogos = (datos) => ({
  regimenes: {
    lista: datos.regimenesFiscales || [],
    etiqueta: (r) => `${r.c_RegimenFiscal} - ${r.descripcion}`,
    clave: (r) => String(r.c_RegimenFiscal),
  },
  usos: {
    lista: datos.usosDeCFDI || [],
    etiqueta: (u) => `${u.c_UsoCFDI} - ${u.descripcion}`,
    clave: (u) => u.c_UsoCFDI,
  },
  formasDePago: {
    lista: datos.formasDePago || [],
    etiqueta: (f) => `${dosDigitos(f.c_FormaPago)} - ${f.descripcion}`,
    clave: (f) => dosDigitos(f.c_FormaPago),
  },
  monedas: { lista: datos.monedas || [], etiqueta: (m) => m.abreviacion || "" },
  vendedores: { lista: datos.vendedores || [], etiqueta: nombreUsuario },
  canales: { lista: datos.canalesVenta || [], etiqueta: (c) => c.nombre || "" },
  proyectos: { lista: datos.proyectos || [], etiqueta: (p) => p.nombre || "" },
  bancos: { lista: datos.bancos || [], etiqueta: (b) => b.nombre || "" },
  precios: { lista: datos.precios || [], etiqueta: (p) => p.nombre || "" },
});

// La dirección principal; el CP y el nombre de la colonia los resuelve el backend al exportar.
const direccionDe = (c) => {
  const d = c.direcciones?.[0] || {};
  return {
    cp: c._cp || "",
    colonia: c._colonia || "",
    calle: d.calle || "",
    numeroCalle: d.numeroCalle ?? "",
    numeroInterior: d.numeroInterior || "",
  };
};

const CONFIG = {
  titulo: "Edición Masiva de Clientes",
  singular: "cliente",
  plural: "clientes",
  idCampo: "clienteId",
  endpoints: {
    datos: "clientes/datosParaEdicionMasivaClientes",
    preview: "clientes/clientesPreviewEdicionMasiva",
    exportar: "clientes/clientesParaExportarEdicionMasiva",
    editar: "clientes/editarClientesMasivo",
  },
  claveExportar: "clientes",
  nombreArchivo: "edicion_masiva_clientes.xlsx",
  hoja: "Clientes",
  grupos: GRUPOS,
  columnas: COLUMNAS,
  catalogos,
  direccionDe,
  filtros: [
    {
      key: "tipoClienteIds",
      placeholder: "Filtrar por Tipo de Cliente",
      opciones: (d) => (d.tiposCliente || []).map((t) => ({ label: t.nombre, value: t._id })),
    },
    {
      key: "vendedorIds",
      placeholder: "Filtrar por Vendedor",
      opciones: (d) => (d.vendedores || []).map((u) => ({ label: nombreUsuario(u), value: u._id })),
    },
  ],
  columnasPreview: [
    { title: "Código", dataIndex: "codigo", key: "codigo", width: 90, sorter: true },
    { title: "Clave", dataIndex: "clave", key: "clave", width: 120, sorter: true },
    { title: "RFC", dataIndex: "rfc", key: "rfc", width: 150, sorter: true },
    { title: "Nombre", dataIndex: "nombre", key: "nombre" },
    { title: "Tipo de Cliente", dataIndex: "tipo", key: "tipo", width: 200 },
  ],
  hojasCatalogo: [
    { nombre: "Catalogo Regimen Fiscal", catalogo: "regimenes", columnas: ["Regimen Fiscal"] },
    { nombre: "Catalogo Uso de CFDI", catalogo: "usos", columnas: ["Uso de CFDI"] },
    { nombre: "Catalogo Forma de Pago", catalogo: "formasDePago", columnas: ["Forma de Pago"] },
    { nombre: "Catalogo Moneda", catalogo: "monedas", columnas: ["Moneda"] },
    { nombre: "Catalogo Vendedores", catalogo: "vendedores", columnas: ["Vendedor"] },
    { nombre: "Catalogo Canales", catalogo: "canales", columnas: ["Canal"] },
    { nombre: "Catalogo Proyectos", catalogo: "proyectos", columnas: ["Proyecto"] },
    { nombre: "Catalogo Bancos", catalogo: "bancos", columnas: ["Banco"] },
    {
      nombre: "Catalogo Listas de Precios",
      catalogo: "precios",
      columnas: ["Precio Contado", "Precio Credito", "Precio Online"],
    },
  ],
  instrucciones: [
    "Instrucciones de uso",
    "",
    "1. La columna ID es OBLIGATORIA y NO debe modificarse ni eliminarse. La columna Codigo es solo para identificar al cliente: no se modifica.",
    "2. Las primeras dos filas son encabezados: la fila 1 agrupa las columnas por sección y la fila 2 trae el nombre de cada columna. No borre ninguna de las dos.",
    "3. Puede BORRAR las columnas que NO desee editar. Solo se modificarán las columnas presentes en el archivo y solo los valores que cambie.",
    "4. RFC: si cambia de 12 a 13 caracteres (o al revés), el cliente pasa a persona física o moral. Persona moral requiere Razon Social; persona física requiere Nombre. No se aceptan RFC repetidos.",
    "5. Columnas SI/NO: use SI o NO. Contado/Credito: use Contado o Credito.",
    "6. Regimen Fiscal, Uso de CFDI, Forma de Pago, Moneda, Vendedor, Canal, Proyecto, Banco y Listas de Precios: escriba el valor tal como aparece en su hoja \"Catalogo ...\". En Regimen, Uso y Forma de Pago basta con la clave (601, G03, 01). Celda vacía = se quita el dato.",
    "7. Correos Adicionales: separe los correos con punto y coma (;).",
    "8. Dirección: se edita solo la dirección principal. Escriba el Codigo Postal y el nombre de la Colonia; si el CP tiene una sola colonia puede dejar la Colonia vacía.",
    "9. El Uso de CFDI debe ser compatible con el Regimen Fiscal; si no lo es, el cliente se rechaza.",
  ],
  ejemplos: {
    ID: ["No modificar (se genera al descargar)"],
    Codigo: ["Solo lectura"],
    Clave: ["CLI-001"],
    RFC: ["ABC010203XY1", "PEGJ800101AB2", "XAXX010101000"],
    "Razon Social": ["DISTRIBUIDORA ABC SA DE CV"],
    Nombre: ["JUAN"],
    "Apellido Paterno": ["PÉREZ"],
    "Apellido Materno": ["GÓMEZ"],
    "Nombre Comercial": ["ABC SUCURSAL NORTE"],
    "Nombre Contacto General": ["María López"],
    Celular: ["5512345678"],
    Telefono: ["5587654321"],
    Correo: ["facturas@cliente.com"],
    "Correos Adicionales": ["compras@cliente.com; pagos@cliente.com"],
    "Pagina Web": ["https://cliente.com"],
    "Nombre Contacto": ["Pedro Ruiz"],
    "Telefono Contacto": ["5511112222"],
    "Correo Contacto": ["pedro@cliente.com"],
    Observaciones: ["Entregar por la mañana"],
    CURP: ["PEGJ800101HDFRMN09"],
    "Regimen Fiscal": ["601 - General de Ley Personas Morales", "612"],
    "Uso de CFDI": ["G03 - Gastos en general", "S01"],
    "Forma de Pago": ["03 - Transferencia electrónica de fondos", "01"],
    Moneda: ["MXN", "USD"],
    Vendedor: ["(nombre de la hoja Catalogo Vendedores)"],
    Canal: ["(nombre de la hoja Catalogo Canales)"],
    Proyecto: ["(nombre de la hoja Catalogo Proyectos)"],
    Banco: ["(nombre de la hoja Catalogo Bancos)"],
    "Contado/Credito": ["Contado", "Credito"],
    "Dias Credito": ["30"],
    "Limite Credito": ["50000"],
    "Limite Descuento": ["10"],
    "Descuento Predeterminado": ["5"],
    "Precio Contado": ["(nombre de la hoja Catalogo Listas de Precios)"],
    "Precio Credito": ["(nombre de la hoja Catalogo Listas de Precios)"],
    "Precio Online": ["(nombre de la hoja Catalogo Listas de Precios)"],
    Leyenda: ["SI", "NO"],
    "Cliente de Portal": ["SI", "NO"],
    "Sin Fecha Vencimiento": ["SI", "NO"],
    "Impresion Especial": ["SI", "NO"],
    "Codigo Proveedor": ["123456789"],
    "Codigo Postal": ["06000"],
    Colonia: ["Centro"],
    Calle: ["Av. Juárez"],
    Numero: ["100"],
    "Numero Interior": ["3B"],
  },
};

class EdicionMasivaClientes extends Component {
  render() {
    return (
      <EdicionMasivaEntidad
        config={CONFIG}
        gruposOcultos={this.props.permisoModificarParametosDeCredito ? [] : ["creditoPrecios"]}
        history={this.props.history}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  permisoModificarParametosDeCredito:
    state.user.tipo === 0 ||
    state.user.permisos.find((valueTodos) => valueTodos.permisoId.toString() === "6999ecf0153232381f120f72")
      ?.activado,
});

export default connect(mapStateToProps)(EdicionMasivaClientes);
